import { Outlet } from 'react-router-dom';
import { RoadmapProvider } from './shared/RoadmapContext';

export default function RoadmapLayout() {
    return (
        <RoadmapProvider>
            <Outlet />
        </RoadmapProvider>
    );
}
